import { LoginForm, SignupForm } from '@/components/auth'
import { useState } from 'react'

export const Login = () => {
  const [isSignup, setIsSignup] = useState(false)

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-primary-600 mb-2">Snippets</h1>
          <p className="text-gray-600">Track your daily activities</p>
        </div>

        <div className="bg-white rounded-lg shadow-md p-8">
          <div className="mb-6">
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">
              {isSignup ? 'Create Account' : 'Welcome Back'}
            </h2>
            <p className="text-sm text-gray-600">
              {isSignup
                ? 'Sign up to start tracking your daily snippets'
                : 'Sign in to continue to your snippets'}
            </p>
          </div>

          {isSignup ? <SignupForm /> : <LoginForm />}

          <div className="mt-6 text-center">
            <button
              onClick={() => setIsSignup(!isSignup)}
              className="text-sm text-primary-600 hover:text-primary-700"
            >
              {isSignup
                ? 'Already have an account? Sign in'
                : "Don't have an account? Sign up"}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
